import { lazy } from 'react';

const ReferralReportRoutes = [
    {
        path: '/reports/referral_reports',
        component: lazy(() => import('../../pages/Reports/ReferralReports')),
        exact: true,
        meta: {
            action: 'read',
            resource: 'referral_reports',
        },
    },
    {
        path: '/reports/referral_reports/applicant_list',
        component: lazy(() =>
            import('../../pages/Reports/ReferralReports/ApplicantList'),
        ),
        meta: {
            action: 'read',
            resource: 'referral_reports',
        },
    },
    {
        path: '/reports/referral_reports/referrals_to_member',
        component: lazy(() =>
            import('../../pages/Reports/ReferralReports/ReferralToMember'),
        ),
        meta: {
            action: 'read',
            resource: 'referral_reports',
        },
    },
    /*  APB */
    {
        path: '/reports/referral_reports/applicant_list_apb',
        component: lazy(() =>
            import('../../pages/Reports/ReferralReports/ApplicantList'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
    {
        path: '/reports/referral_reports/referrals_to_member_apb',
        component: lazy(() =>
            import('../../pages/Reports/ReferralReports/ReferralToMember'),
        ),
        meta: {
            action: 'read',
            resource: 'apb_reports',
        },
    },
];

export default ReferralReportRoutes;
